import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import { ErrorMessage, Field, } from 'formik'
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../../CommonUtilities/CommonAxios/CommonAxios';

export default function ExamCenters(props) {
    const { Data } = props
    const [examData, setExamData] = useState()
    const getExamDataFunction = () => {
        let villUrl = config.url.CONTEXT_READ_URL + "exam-centers";
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data?.status === true) {
                setExamData(response?.data?.examcenters)
            }
            else {
                setExamData([])
            }
        });
    };
    useEffect(() => { getExamDataFunction() }, [])
    return (
        <React.Fragment>
            <div className="personal-head mt-3">
                <span>Examination  Center Preferred Places</span>
            </div>
            <div className="personal-row pb-3">
                <Row className='px-3'>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12}>
                        <table className="table table-condensed table-bordered table-striped table-responsive"
                            style={{ borderCollapse: 'collapse', border: '1px solid skyblue' }}>
                            <thead style={{
                                backgroundColor: '#dbe9f4'
                            }}>
                                <tr>
                                    <th>Preference Order</th>
                                    <th>Exam Centers</th>
                                </tr>
                            </thead>

                            {Data?.length > 0 ? <tbody>{Data?.map((item, index) => {
                                return (<tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item?.district}</td></tr>)
                            })}</tbody> :
                                <tbody>
                                    <tr><td>1.</td>
                                        <td>
                                            <Field as="select" className="form-control"
                                                name='option1'>
                                                <option value="">Select</option>
                                                {examData?.map((data, index) => {
                                                    return (
                                                        <option key={index} id={index} value={data?.city_dist_code}>{data?.district}</option>
                                                    )
                                                })}
                                            </Field>
                                            <ErrorMessage
                                                name='option1'
                                                component="div"
                                                className="text-error"
                                            />
                                        </td>
                                    </tr>
                                    <tr><td>2.</td>
                                        <td>
                                            <Field as="select" className="form-control"
                                                name='option2'>
                                                <option value="">Select</option>
                                                {examData?.map((data, index) => {
                                                    return (
                                                        <option key={index} id={index} value={data?.city_dist_code}>{data?.district}</option>
                                                    )
                                                })}
                                            </Field>
                                            <ErrorMessage
                                                name='option2'
                                                component="div"
                                                className="text-error"
                                            />
                                        </td>
                                    </tr>
                                    <tr><td>3.</td>
                                        <td>
                                            <Field as="select" className="form-control"
                                                name='option3'>
                                                <option value="">Select</option>
                                                {examData?.map((data, index) => {
                                                    return (
                                                        <option key={index} id={index} value={data?.city_dist_code}>{data?.district}</option>
                                                    )
                                                })}
                                            </Field>
                                            <ErrorMessage
                                                name='option3'
                                                component="div"
                                                className="text-error"
                                            />
                                        </td>
                                    </tr>
                                    <tr><td>4.</td>
                                        <td>
                                            <Field as="select" className="form-control"
                                                name='option4'>
                                                <option value="">Select</option>
                                                {examData?.map((data, index) => {
                                                    return (
                                                        <option key={index} id={index} value={data?.city_dist_code}>{data?.district}</option>
                                                    )
                                                })}
                                            </Field>
                                            <ErrorMessage
                                                name='option4'
                                                component="div"
                                                className="text-error"
                                            />
                                        </td>
                                    </tr>
                                    <tr><td>5.</td>
                                        <td>
                                            <Field as="select" className="form-control"
                                                name='option5'>
                                                <option value="">Select</option>
                                                {examData?.map((data, index) => {
                                                    return (
                                                        <option key={index} id={index} value={data?.city_dist_code}>{data?.district}</option>
                                                    )
                                                })}
                                            </Field>
                                            <ErrorMessage
                                                name="option5"
                                                component="div"
                                                className="text-error"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            }

                        </table>
                    </Col>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12} >
                        {/* <img src={`${process.env.PUBLIC_URL}/img/examcenter.webp`} alt='exam' className='img-flui w-75 m-auto d-block border border-dark' style={{ height: '250px', width: '133px' }} /> */}
                        {/* <div className="alert alert-warning">
                        <strong>Regular:</strong> Candidates who have not studied in
                            any educational institution during the whole or part of
                            preceding 7 years of study in which he/she appeared for the
                            SSC examination.

                        </div> */}
                        {/* <div className="alert alert-warning">
                            <strong>Private :</strong> Candidates who have not studied in
                            any educational institution during tShe whole or part of
                            preceding 7 years of study in which he/she appeared for the
                            SSC examination.
                            <hr className='my-3' />
                            In case where visually handicapped and hearing handicapped persons studied in the special schools
                            meant for them, the native place of the parents of such visually handicapped and hearing
                            handicapped person will be the local area.
                        </div> */}
                        {/* <Row>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12}>
                                <img img src={`${process.env.PUBLIC_URL}/img/image.png`} alt='' height={320} width={500} /></Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12}><div className="alert alert-warning">
                                <strong>Regular:</strong> Candidates who have not studied in
                                any educational institution during the whole or part of
                                preceding 7 years of study in which he/she appeared for the
                                SSC examination.

                            </div></Col>
                        </Row> */}
                        {/* <div className="alert alert-warning">
                            <div class="container">
                                <div class="header">The Most Out Of Work PowerPoint Template</div>
                                <div class="subheader">
                                    This slide is an editable slide with all your needs. Adapt it with your needs and it will capture all the audience attention. Capture your audience attention.
                                </div>
                                <div class="illustration">
                                    <div class="desk"></div>
                                    <div class="person">
                                        <div class="head"></div>
                                    </div>
                                    <div class="monitor"></div>
                                    <div class="lamp">
                                        <div class="lamp-head"></div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className='text-danger'>
                            {/* <img src={`${process.env.PUBLIC_URL}/img/examcenter.webp`} alt='exam' className='img-flui w-75 m-auto d-block border border-dark' style={{ height: '250px', width: '100px' }} /> */}
                            {/* <img src={`${process.env.PUBLIC_URL}/img/dscimage.png`} alt='exam' className='img-flui w-75 m-auto d-block' style={{ height: '250px', width: '100px' }} /> */}
                            <ul className='ms-5 mt-1'>
                                <li>
                                    Once submitted ,Examination centers will not be editable.
                                </li>
                                <li>
                                    Examination centers will  be assigned according to entered preference number.
                                </li>
                            </ul>
                        </div>
                    </Col>

                </Row>

            </div>
        </React.Fragment>
    )
}
